/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
function hideSezeriumBadges() {
  document.querySelectorAll('.sezerium-sold-out-badge > .sezerium-badge').forEach(function(badge) {
    badge.style.setProperty('display', 'none', 'important');
  });
}

hideSezeriumBadges();

new MutationObserver(hideSezeriumBadges).observe(document.body, {
  childList: true,
  subtree: true
});

  /* Houdini okt 2026: jacktypsväljaren (Highlights-knappar) som små pills på mobil
     på kollektionssidor, så att 3–4 val syns samtidigt i stället för ett.
     Ligger här eftersom temats Custom CSS är full (gräns 1 500 tecken).
     Påverkar bara bredden i sidled, inte sidans höjd. */
  (function hsPills() {
    if (!document.body.classList.contains('template-collection')) return;
    var s = document.createElement('style');
    s.id = 'hs-highlights-pills';
    s.textContent = '@media (max-width:767px){' +
      '.highlights__items--mobile-slider{gap:8px;scroll-snap-type:none}' +
      '.highlights__item--button{width:auto!important;min-width:0!important;flex:0 0 auto!important;margin:0!important;padding:0!important}' +
      '.highlights__item--button .highlights__item-inner{min-width:0!important;width:auto!important;padding:8px 16px!important;border-radius:999px!important;white-space:nowrap}' +
      '}';
    document.head.appendChild(s);
  })();

  /* Houdini okt 2026: storleksfiltret visar bara produkter där vald storlek finns i lager.
     Shopify filtrerar annars på att storleken finns, även om den är slutsåld.
     När en storlek väljs slås "Tillgänglighet: I lager" på automatiskt. */
  var HS_SIZE = 'filter.v.option.size';
  var HS_STOCK = 'filter.v.availability';

  (function hsEnsureStockInUrl() {
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.has(HS_SIZE) && !u.searchParams.has(HS_STOCK)) {
        u.searchParams.set(HS_STOCK, '1');
        window.location.replace(u.toString());
      }
    } catch (e) {}
  })();

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== HS_SIZE || !t.checked) return;
    var form = t.form || document;
    var stock = form.querySelector('input[name="' + HS_STOCK + '"][value="1"]');
    if (stock && !stock.checked) stock.checked = true;
  }, true);

  /* Houdini okt 2026: "X kr från fri frakt" i varukorgslådan.
     Gränserna MÅSTE matcha det kassan (Ingrid) faktiskt gör – INTE Shopify Settings > Shipping,
     som har andra värden som inte används. Kontrollerat mot ordrar okt 2026:
     fri frakt när totalen är ÖVER gränsen (exakt 1500 kr betalar frakt).
     SEK 1500, EUR 139, NOK 1699, USD 149, CAD 199. Ändras Ingrids regler – ändra här också.
     Temats inbyggda block används inte, eftersom det räknar om ett SEK-belopp med dagskurs.
     Valutor utan gräns nedan visar ingen bar. */
  (function hsFreeShipping() {
    var LIMITS = { SEK: 1500, EUR: 139, NOK: 1699, USD: 149, CAD: 199 };
    var lang = (document.documentElement.lang || 'sv').slice(0, 2);
    var T = {
      sv: { left: 'Du är {x} från fri frakt', done: 'Du har fri frakt!', loc: 'sv-SE' },
      en: { left: 'You are {x} away from free shipping', done: 'You have free shipping!', loc: 'en-GB' },
      de: { left: 'Noch {x} bis zum kostenlosen Versand', done: 'Dein Versand ist kostenlos!', loc: 'de-DE' }
    };
    var tr = T[lang] || T.en;
    var last = null;
    var busy = false;

    function css() {
      if (document.getElementById('hs-fs-style')) return;
      var s = document.createElement('style');
      s.id = 'hs-fs-style';
      s.textContent = '.hs-fs{padding:12px 16px 14px;border-bottom:1px solid rgba(0,0,0,.1);font-size:13px;line-height:1.3}' +
        '.hs-fs[hidden]{display:none}' +
        '.hs-fs__bar{margin-top:8px;height:4px;background:#e4e4e0;overflow:hidden}' +
        '.hs-fs__fill{height:100%;background:#000;transition:width .3s ease}';
      document.head.appendChild(s);
    }

    function fmt(amount, cur) {
      var whole = Math.abs(amount - Math.round(amount)) < 0.005;
      try {
        return new Intl.NumberFormat(tr.loc, { style: 'currency', currency: cur, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(amount);
      } catch (e) { return amount.toFixed(whole ? 0 : 2) + ' ' + cur; }
    }

    function ensureBar() {
      var inner = document.querySelector('cart-drawer [data-cart-drawer-inner]');
      if (!inner) return null;
      var bar = inner.querySelector('.hs-fs');
      if (!bar) {
        css();
        bar = document.createElement('div');
        bar.className = 'hs-fs';
        bar.hidden = true;
        bar.setAttribute('aria-live', 'polite');
        bar.innerHTML = '<div class="hs-fs__text"></div><div class="hs-fs__bar"><div class="hs-fs__fill" style="width:0"></div></div>';
        var body = inner.querySelector('[data-cart-drawer-body]');
        inner.insertBefore(bar, body || inner.firstChild);
      }
      return bar;
    }

    function render(cart) {
      last = cart;
      var bar = ensureBar();
      if (!bar || !cart) return;
      var cur = cart.currency;
      var limit = LIMITS[cur];
      if (!limit || !cart.item_count) { bar.hidden = true; return; }
      var total = (cart.total_price || 0) / 100;
      var free = total > limit;
      // Fri frakt gäller över gränsen: vid exakt gränsen saknas minsta enheten (1 kr / 1 €).
      var left = free ? 0 : Math.max(limit - total, 1);
      var pct = free ? 100 : Math.min(99, (total / limit) * 100);
      bar.querySelector('.hs-fs__text').textContent = free ? tr.done : tr.left.replace('{x}', fmt(left, cur));
      bar.querySelector('.hs-fs__fill').style.width = pct + '%';
      bar.hidden = false;
    }

    function refresh() {
      if (busy) return;
      busy = true;
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { busy = false; render(c); })
        .catch(function () { busy = false; });
    }

    // Uppdatera efter varje varukorgsändring (lägg till, ändra antal, ta bort).
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(refresh, 150); }).catch(function () {});
      }
      return p;
    };

    // Lådan byggs om vid ändringar – lägg tillbaka baren om den försvinner.
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var inner = document.querySelector('cart-drawer [data-cart-drawer-inner]');
        if (inner && !inner.querySelector('.hs-fs')) { if (last) render(last); else refresh(); }
      }, 100);
    }).observe(document.body, { childList: true, subtree: true });

    refresh();
  })();




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
